import React, { forwardRef } from 'react';

import { Popover } from '@vlabs/monokit/shared/ui/popovers';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { SourceGroupedCheckbox } from '@vlabs/shared/components/filters-panel/common/source-select-popover/components/SourceGroupedCheckbox';
import { useFormContext } from 'react-hook-form';

const DEFAULT_SOURCES_FIELD = 'sources';
const CREATED_SOURCES_FIELD = '__createdSources__';

function VideoSourceFilterPopover(
  {
    style,
    ...props
  }: FilterPopoverProps<string[]>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { setValue, watch } = useFormContext();
  const selectedSources = watch(DEFAULT_SOURCES_FIELD) ?? [];
  // служебное поле, подумать мб для группы "Добавленные источники" сделать хранение используя react-query
  const createdSources = watch(CREATED_SOURCES_FIELD) ?? [];

  return (
    <Popover
      {...props}
      ref={ref}
      rootProps={{
        ...props?.rootProps,
        style,
      }}
    >
      <SourceGroupedCheckbox
        customSourceNames={createdSources}
        onChangeCustomSourceNames={(v) => setValue(CREATED_SOURCES_FIELD, v)}
        onChangeSelectedSource={(v) => setValue(DEFAULT_SOURCES_FIELD, v)}
        selectedSources={selectedSources}
      />
    </Popover>
  );
}

const VideoSourceFilterPopoverWithRef = forwardRef(VideoSourceFilterPopover);
export { VideoSourceFilterPopoverWithRef as VideoSourceFilterPopover };
